<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="modals[modalType]"
      :width="width"
      :top="top"
      :close-on-click-modal="isCloseModal"
      :before-close="handleClose"
      :close-on-press-escape="false"
      @open="handleOpen"
    >
      <card class="custom-shadow-card-header">
        <slot name="form"></slot>
        <dialog-button-form
          :modalName="modalType"
          :toRight="true"
          @closeModal="closeModal"
          @validate="$emit('validate')"
          classButton="my-3"
          :labelButtonSuccess="$t('common_words.confirm')"
          slot="footer"
        />
      </card>
    </el-dialog>
  </div>
</template>

<script>
import ButtonForm from 'src/components/Dialogs/Forms/ButtonForm';

export default {
  name: 'create-dialog',
  components: {
    [ButtonForm.name]: ButtonForm,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '75%',
    },
    top: {
      type: String,
      default: '2%',
    },
    modalType: {
      type: String,
      default: 'create',
    },
    isCloseModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      modals: {
        create: false,
      },
    };
  },
  methods: {
    closeModal() {
      this.modals[this.modalType] = false;
      this.$emit('closeModal');
    },
    handleClose(done) {
      done();
      this.$emit('closeModal');
    },
    handleOpen() {
      this.$emit('handleOpen');
    },
  },
};
</script>
